<template>
  <div
    class="flex md:flex-row flex-col rounded-lg bg-white shadow-xl justify-between p-6 hover:bg-opacity-75 border-solid border-2 border-white transition-all ease-in duration-100"
  >
    <div
      class="flex md:flex-row flex-col md:items-start items-start justify-start w-full gap-6"
    >
      <div
        @click="$router.push(``)"
        class="flex rounded-lg overflow-hidden relative justify-center items-center p-4 cursor-pointer"
        :style="{ background: boardTemplateData.backgroundColor }"
        style="
          min-width: 10rem !important;
          min-height: 10rem !important;
          max-width: 10rem !important;
          max-height: 10rem !important;
        "
      >
        <img
          class="w-full h-full flex object-cover"
          :src="boardTemplateData.icon"
          :alt="boardData.title"
        />
      </div>

      <div class="flex flex-col justify-center h-full text-left gap-6">
        <h4
          class="text-3xl font-medium text-slate-600 hover:text-slate-900 cursor-pointer transition-all duration-200 ease-in-out board-clamp"
          @click="$router.push(``)"
        >
          {{ boardData.title }}
        </h4>
        <span
          v-if="boardData.description"
          class="hidden flex-col gap-2 text-lg font-normal text-slate-400"
        >
          <span class="flex font-semibold text-slate-700 whitespace-no-wrap"
            >Subject :
          </span>
          <span
            class="flex whitespace-normal flex-wrap w-fit text-base gap-2"
            v-html="boardData.description"
          />
        </span>

        <div
          class="flex items-center text-base mt-2 gap-3 flex-wrap"
          v-if="boardData.skill.length > 0"
        >
          <span class="font-semibold text-slate-700">Skills : </span>

          <span
            v-for="(skill, index) in boardData.skill"
            :key="index"
            class="flex font-normal text-slate-700 rounded-full px-2 py-1 border-grey border-solid"
            style="border: 1px"
          >
            {{ skill }}</span
          >
        </div>
      </div>
    </div>

    <div class="hidden items-start">
      <div class="dropdown-board relative flex-col justify-end flex">
        <button
          class="font-normal text-slate-700 rounded-lg w-48 border-grey border-solid items-center bg-white justify-between flex text-xl gap-4 overflow-hidden"
          style="border: 1px; font-family: Poppins"
        >
          <span class="px-4">Manage</span>

          <div
            class="flex items-center bg-slate-200 h-full justify-center py-3 px-4"
          >
            <svg
              class="fill-current h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                fill="#8F9395"
              />
            </svg>
          </div>
        </button>

        <span class="py-1 px-2 bg-transparent"></span>

        <ul
          class="items absolute hidden text-gray-700 text-left flex-col left-0 shadow-lg rounded-lg overflow-hidden w-full"
          style="top: 100%"
        >
          <span
            class="items__option px-4 py-4 text-lg flex items-start gap-2 bg-white text-slate-500"
          >
            <span class="w-6 relative flex items-center h-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 256 256"
                fill="none"
              >
                <path
                  d="M128 24C107.431 24 87.3235 30.0995 70.2207 41.5272C53.118 52.9548 39.7881 69.1974 31.9166 88.2009C24.0451 107.204 21.9855 128.115 25.9984 148.289C30.0112 168.463 39.9163 186.994 54.4609 201.539C69.0056 216.084 87.5366 225.989 107.711 230.002C127.885 234.015 148.796 231.955 167.799 224.083C186.803 216.212 203.045 202.882 214.473 185.779C225.901 168.677 232 148.569 232 128C231.971 100.426 221.004 73.9905 201.507 54.4931C182.01 34.9956 155.574 24.0291 128 24ZM128 216C110.595 216 93.5814 210.839 79.1099 201.169C64.6383 191.5 53.3592 177.756 46.6986 161.676C40.0381 145.596 38.2954 127.902 41.6909 110.832C45.0864 93.7617 53.4676 78.0816 65.7747 65.7746C78.0817 53.4676 93.7618 45.0864 110.832 41.6909C127.902 38.2954 145.596 40.0381 161.676 46.6986C177.756 53.3591 191.5 64.6383 201.169 79.1098C210.839 93.5813 216 110.595 216 128C215.974 151.331 206.694 173.699 190.196 190.196C173.699 206.694 151.331 215.974 128 216ZM144 176C144 178.122 143.157 180.157 141.657 181.657C140.157 183.157 138.122 184 136 184C131.757 184 127.687 182.314 124.686 179.314C121.686 176.313 120 172.243 120 168V128C117.878 128 115.843 127.157 114.343 125.657C112.843 124.157 112 122.122 112 120C112 117.878 112.843 115.843 114.343 114.343C115.843 112.843 117.878 112 120 112C124.244 112 128.313 113.686 131.314 116.686C134.314 119.687 136 123.757 136 128V168C138.122 168 140.157 168.843 141.657 170.343C143.157 171.843 144 173.878 144 176ZM112 84C112 81.6266 112.704 79.3066 114.022 77.3332C115.341 75.3598 117.215 73.8217 119.408 72.9134C121.601 72.0052 124.013 71.7676 126.341 72.2306C128.669 72.6936 130.807 73.8365 132.485 75.5147C134.164 77.1929 135.306 79.3311 135.769 81.6589C136.232 83.9867 135.995 86.3995 135.087 88.5922C134.178 90.7849 132.64 92.6591 130.667 93.9776C128.693 95.2962 126.373 96 124 96C120.817 96 117.765 94.7357 115.515 92.4853C113.264 90.2348 112 87.1826 112 84Z"
                  fill="#1A6FBD"
                />
              </svg>
            </span>
            <span>Details</span>
          </span>

          <span
            class="items__option px-4 py-4 text-lg flex items-start gap-2 bg-white text-slate-500"
          >
            <span class="w-6 relative flex items-center h-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  stroke="#F02806"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15 9L9 15"
                  stroke="#F02806"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 9L15 15"
                  stroke="#F02806"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span>Leave Board</span>
          </span>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import boardTemplates from "@/assets/data/board-templates.js";

export default {
  data() {
    return {
      boardTemplates,
      boardTemplateData: {},
    };
  },
  props: {
    boardData: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.boardTemplateData = this.boardTemplates.find(
      (boardTemplate) => boardTemplate.id === this.boardData.boardId
    );
  },
};
</script>

<style lang="scss">
.board-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 3;
}

.dropdown-board:hover {
  .items {
    display: flex !important;

    &__option:hover {
      background-color: rgb(241, 241, 241) !important;
      cursor: pointer;
    }
  }
}
</style>
